import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import NonStatutoryAdviceServices from "./NonStatutoryAdviceServices";
import { toast } from "react-toastify";
// import { successAlert } from "../../Global/GlobalSlice";

export const getNonStatutoryAdviceReviewer = createAsyncThunk(
  "nsa/getNonStatutoryAdviceReviewer",
  async (data, { rejectWithValue }) => {
    try {
      const responseData =
        await NonStatutoryAdviceServices.getNonStatutoryAdviceReviewer(data);

      // if (responseData?.successful === true) {
      //   dispatch(
      //     successAlert({
      //       message: responseData?.statusMessage,
      //     })
      //   );
      // }

      console.log({ responseData });

      return responseData;
    } catch (error) {
      console.log({ error });
      toast.error(error?.response?.data?.statusMessage);
      return rejectWithValue(error?.response?.data);
    }
  }
);

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const reducers = {
  viewData(state, action) {
    return { ...state, data: action.payload };
  },
};

export const NonStatutoryAdviceSlice = createSlice({
  name: "nsa",
  initialState,
  reducers,
  extraReducers: (builder) => {
    builder
      .addCase(getNonStatutoryAdviceReviewer.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        };
      })
      .addCase(getNonStatutoryAdviceReviewer.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          data: action.payload,
        };
      })
      .addCase(getNonStatutoryAdviceReviewer.rejected, (state, action) => {
        return {
          ...state,
          error: action.payload,
        };
      });
  },
});

export const { viewData } = NonStatutoryAdviceSlice.actions;

export default NonStatutoryAdviceSlice.reducer;
